import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useReducer,
  useState,
} from 'react';
import { useLocation } from 'react-router-dom';

import reducer, { initialState } from './reducer';
import actionsFactory from './reducer/actions';

const initialContext = {
  ...initialState,
  filterActions: actionsFactory(() => {}),
};

const ExperienceFilterContext = createContext(initialContext);
const useExperienceFilterContext = () => useContext(ExperienceFilterContext);

function ExperienceFilterContextProvider({ children }) {
  const [isPristine, setIsPristine] = useState(true);
  const [state, dispatch] = useReducer(reducer, initialState);
  const filterActions = useMemo(() => actionsFactory(dispatch), [dispatch]);
  const location = useLocation();

  const contextValue = { ...state, filterActions };

  useEffect(() => {
    if (isPristine) {
      filterActions.setInitials(location);
      setIsPristine(false);
    }
  }, [filterActions, isPristine, location]);

  return (
    <ExperienceFilterContext.Provider value={contextValue}>
      {children}
    </ExperienceFilterContext.Provider>
  );
}

export { useExperienceFilterContext, ExperienceFilterContextProvider };
